import { render, staticRenderFns } from "./BaseListPage.vue?vue&type=template&id=22ef4cb2&"
import script from "./BaseListPage.vue?vue&type=script&lang=js&"
export * from "./BaseListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports